import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ProductsService } from 'src/app/services/products.service';

@Component({
  selector: 'app-dialog-delete-basket',
  templateUrl: './dialog-delete-basket.component.html',
  styleUrls: ['./dialog-delete-basket.component.css']
})
export class DialogDeleteBasketComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private productsService: ProductsService) { }

  onDelete(ID) {
    this.productsService.deleteBasket(ID);
  }
}
